import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const SIDEBAR_WIDTH = 256; // w-64 is 16rem = 256px

const LayoutWrapper = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // Mobile state
  const [isMobile, setIsMobile] = useState(false);

  const handleSidebarToggle = useCallback(() => {
    setSidebarOpen(prev => !prev);
  }, []);

  const handleSidebarClose = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  const handleMainClick = useCallback(() => {
    if (isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  }, [isMobile, sidebarOpen]);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const marginLeft = isMobile ? 0 : SIDEBAR_WIDTH;

  return (
    <div className="bg-white min-h-screen font-sans text-gray-900">
      <Navbar 
        sidebarWidth={marginLeft} 
        sidebarOpen={sidebarOpen} 
        setSidebarOpen={handleSidebarToggle}
        isMobile={isMobile}
      />
      
      <Sidebar 
        open={sidebarOpen} 
        onClose={handleSidebarClose}
        isMobile={isMobile}
      />
      
      <main
        className="transition-all duration-300 ease-in-out"
        style={{ 
          marginLeft: `${marginLeft}px`, 
          paddingTop: '3.5rem', // Navbar is usually h-14 (56px) in this SaaS style
          minHeight: '100vh'
        }}
        onClick={handleMainClick}
      >
        <div className="p-3 sm:p-4 w-full">
          {children}
        </div>
      </main>
    </div>
  );
};

export default LayoutWrapper;
